import './assets/styles/main.css'

import App from './App.vue'
import router from './router'
import Lara from '@/presets/lara';
import PrimeVue from "primevue/config";
import Tooltip from 'primevue/tooltip';
import Ripple from 'primevue/ripple';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import * as Sentry from "@sentry/vue";

import { createApp } from 'vue'
import { createPinia } from 'pinia'


const app = createApp(App)

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
    Sentry.init({
        app,
        dsn: sentryDsn,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
        release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: import.meta.env.VITE_SENTRY_ENVIRONMENT === 'production' ? 0.2 : 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        tracePropagationTargets: [
            'localhost',
            /^https:\/\/techknital\.wm-staging\.co\.uk/,
            /^https:\/\/techknital\.new\.wm-staging\.co\.uk/,
            /^https:\/\/techknital\.writemedia\.co\.uk/,
        ],
    });
}

app.use(createPinia())
app.use(router)


app.use(PrimeVue, {
    unstyled: true,
    ripple: true,
    pt: Lara
})
app.use(ToastService);
app.use(ConfirmationService);
app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple);

app.mount('#app')